import { typographyCss } from '@creditornot/cb-ingredients';
import { pxToRem } from '@creditornot/cb-utils';
import { Player } from '@lottiefiles/react-lottie-player';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled, { css } from 'styled-components';

import { useIsMobile } from 'common/hooks/useIsMobile';
import { Typography as T } from 'common/typography';
import closing from 'lottie/closing_cropped.json';

const CampaignErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-block-start: 20px;
  flex: 1 1 auto;
`;

const styledContent = css`
  margin-inline: ${pxToRem(24)};
  text-align: center;
`;

const Title = styled.h4`
  ${typographyCss.Heading4}
  font-weight: 700;
  margin-block: ${pxToRem(8)};
  ${styledContent}
`;

const Description = styled(T.Body3)`
  margin-block-start: ${pxToRem(8)};
  ${styledContent}
`;

export const EmptyCampaignAnalyticsState = ({ startDate, className }: { startDate: string; className?: string }) => {
  const isMobile = useIsMobile();
  const style = isMobile ? { height: '150px', width: '225px' } : { height: '300px', width: '375px' };
  return (
    <CampaignErrorContainer className={className}>
      <Player autoplay loop src={closing} style={style}></Player>
      <Title>
        <FormattedMessage
          id="campaigns.analytics-empty-state-title"
          values={{
            startDate,
          }}
        />
      </Title>
      <Description>
        <FormattedMessage id="campaigns.analytics-empty-state-description" />
      </Description>
    </CampaignErrorContainer>
  );
};
